import { render, staticRenderFns } from "./customerCard.vue?vue&type=template&id=020d057e&"
import script from "./customerCard.vue?vue&type=script&lang=js&"
export * from "./customerCard.vue?vue&type=script&lang=js&"
import style0 from "./customerCard.vue?vue&type=style&index=0&id=020d057e&prod&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports